/* app/js/src/components/calendar/choose-segment/choose-segment.component.scss */
.lblLoading,
.lblNoSegmentsFound {
  text-align: center;
}
/*# sourceMappingURL=choose-segment.component.css.map */
